<!--
  ~ Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<h2 class="page-heading">User Management</h2>
<div class="table-filters">
  <form [formGroup]="formFilter" #formDirective="ngForm" novalidate>
    <div class="row table-filter-row">
      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
        <mat-label class="label-input">Filter by</mat-label>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-form-field floatLabel="float">
          <mat-select
            formControlName="filterByCtr"
            ngDefaultControl
            placeholder="filter by"
            [(ngModel)]="typeFilterTerm"
            (ngModelChange)="processFilter()"
          >
            <mat-option [value]="undefined"></mat-option>
            <mat-option *ngFor="let type of types" [value]="type.value">
              {{ type.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-form-field floatLabel="float">
          <input
            matInput
            type="text"
            ngDefaultControl
            #availableFilter
            (keyup)="sourceFilterKeyup.emit(availableFilter.value)"
            placeholder="filter criteria"
          />
          <mat-icon
            matSuffix
            fontIcon="Bosch-Ic-search"
            style="height: 40px"
          ></mat-icon>
        </mat-form-field>
      </div>

      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
        <mat-label class="label-input">Site</mat-label>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-form-field floatLabel="float">
          <mat-select
            formControlName="siteCtr"
            ngDefaultControl
            placeholder="Select Site"
            [(ngModel)]="siteFilterTerm"
            (ngModelChange)="processFilterBySite()"
          >
            <mat-option [value]="undefined"></mat-option>
            <mat-option *ngFor="let site of sites" value="{{ site.SiteId }}">
              {{ site.SiteName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pull-right add-user">
        <button
          (click)="addUser()"
          bciprimarybutton
          class="button-primary"
          id="addUserbtn"
          [disabled]="!NEW_USER"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-user-add"
              style="width: max-content"
            ></mat-icon> </span
          >Add new user
        </button>
      </div>
    </div>
  </form>
</div>

<div class="user-table">
  <mat-table
    [dataSource]="dataSource"
    class="hover my-custom-scrollbar"
    matSort
  >
    <ng-container matColumnDef="no">
      <mat-header-cell *matHeaderCellDef> #</mat-header-cell>
      <mat-cell *matCellDef="let user; let rindex = index">{{
        rindex + 1
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="username">
      <mat-header-cell *matHeaderCellDef> User ID</mat-header-cell>
      <mat-cell *matCellDef="let user"> {{ user.ntId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> Email</mat-header-cell>
      <mat-cell *matCellDef="let user"> {{ user.username }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="role">
      <mat-header-cell *matHeaderCellDef> Role</mat-header-cell>
      <mat-cell *matCellDef="let user"> {{ user.role }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Site">
      <mat-header-cell *matHeaderCellDef> Site</mat-header-cell>
      <mat-cell *matCellDef="let user">
        {{ arrayToString(user.sites) }}</mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <button
          bciprimarybutton
          class="button-primary"
          (click)="editUser(user)"
          [disabled]="!EDIT_USER"
          style="margin-left: 0.5rem"
        >
          <i class="Bosch-Ic Bosch-Ic-edit" aria-hidden="true"></i>
        </button>
        <button
          bciprimarybutton
          class="button-primary"
          (click)="removeUser(user)"
          [disabled]="!DELETE_USER"
          style="margin-left: 0.5rem"
        >
          <i class="Bosch-Ic Bosch-Ic-delete" aria-hidden="true"> </i>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></mat-header-row>
    <mat-row *matRowDef="let user; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
